<template>
	<b-row class="application-documents">
		<b-col md="6" class="application-documents-input">
			<div v-if="exists(uploadedDocuments)" class="mb-3">
				<h5 class="mb-0 p-0">New Documents</h5>
				<p class="section-help-text">Documents added here will be attached to this application.</p>
			</div>
			<uppy-uploader
				file-disk="application"
				help="Select a pdf, doc, jpg, jpeg or png to upload."
				allowed-file-types="application/pdf,image/jpeg,image/png,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
				type="document"
				model-type="application"
				:model-id="applicationId"
				:path="`/application/${applicationId}`"
				@file-upload-complete="getFiles" />
		</b-col>
		<b-col v-if="exists(uploadedDocuments)">
			<h5 class="mb-0 p-0">Attached Documents</h5>
			<p class="section-help-text">These documents have been uploaded.</p>
			<ul class="documents-list">
				<li v-for="(doc, index) in uploadedDocuments" :key="`doc-` + index">
					<div class="document-name">{{ doc.name }}</div>
					<a href="#delete" title="Delete File" class="document-remove" @click.prevent="removeDocument(index)">
						<font-awesome-icon :icon="['fas', 'times']" />
					</a>
				</li>
			</ul>
		</b-col>
	</b-row>
</template>
<script>
import api from '@/lib/api'
import UppyUploader from '@/Component/UppyUploader.vue'

export default {
	components: {UppyUploader},
	props: {
		context: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			uploadedDocuments: []
		}
	},
	computed: {
		appValues () {
			return this.$store.getters.appValues
		},
		applicationId () {
			return this.$store.getters.applicationId
		},
		uploadUrl () {
			return this.route('form.files.attach', {
				'application': this.applicationId
			})
		}
	},
	mounted () {
		this.getFiles()
	},
	methods: {
		removeDocument (documentIndex) {
			const url = this.route('form.files.trash', {
				'application': this.applicationId
			})

			const data = {
				'file_id': this.uploadedDocuments[documentIndex].id
			}

			this.uploadedDocuments.splice(documentIndex,1)
			this.$inertia.post(url, data, {
				preserveScroll: true,
				preserveState: true
			})
		},
		uploadComplete () {
			this.getFiles()
		},
		getFiles () {
			const url = this.route('form.files', {
				application: this.applicationId
			})

			const method = 'GET'
			const data = {}

			return api({
				method,
				url,
				data
			}).then((response) => {
				this.uploadedDocuments = response.data
			})
		}
	}
}
</script>
